import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import { DescriptionModalProps } from "../../Types/types";
import { FaTimes } from "react-icons/fa";

const DescriptionModal: React.FC<DescriptionModalProps> = ({
  open,
  handleClose,
  description,
}) => {

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "300px",
          minHeight: "200px",
        },
      }}
    >
      <DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 4,
            top: 2,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <FaTimes color="gray" size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <p className=" font-light">{description}</p>
      </DialogContent>
    </Dialog>
  );
};

export default DescriptionModal;
